export var changelog = {
    releases: [{
        version: '1.0',
        date: '4/13/2022',
        changes: [{
            text: 'Initial release'
        }]
    }]
};